import React from 'react';
import clsx from 'clsx';
import { Button, Icon } from '@kontentino/ui';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { ChecklistTaskState } from 'app/modules/onboardingChecklist/types';

interface ChecklistTaskItemProps {
  task: ChecklistTaskState;
}

const ChecklistTaskItem = ({ task }: ChecklistTaskItemProps) => {
  const { id, title, description, ctaLabel, isDone, perform } = task;

  return (
    <li
      className={clsx(
        'tw-flex tw-items-start tw-gap-3 tw-border-b tw-border-grayscale-10 tw-p-3 tw-transition-colors last:tw-border-b-0',
        isDone ? 'tw-bg-grayscale-5' : 'tw-bg-white',
      )}
      data-cy={`onboarding-checklist_task_${id}`}
      data-name={`onboarding-checklist-${id}`}
      data-state={isDone ? 'done' : 'pending'}
    >
      <div
        className={clsx(
          'tw-mt-1 tw-flex tw-h-5 tw-w-5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full',
          isDone
            ? 'tw-bg-success-100'
            : 'tw-border tw-border-grayscale-20 tw-bg-white',
        )}
      >
        {isDone && <Icon icon={faCheck} size="sm" className="tw-text-white" />}
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1">
        <div
          className={clsx(
            'tw-flex tw-items-center tw-gap-2 tw-text-md',
            isDone
              ? 'tw-text-grayscale-100 tw-line-through'
              : 'tw-text-grayscale-180',
          )}
        >
          <span>{title}</span>
        </div>
        <div className="tw-text-sm tw-text-grayscale-100">{description}</div>
        {!isDone && ctaLabel && (
          <div className="tw-mt-1">
            <Button
              variant="tertiary"
              size="small"
              onClick={perform}
              data-cy={`onboarding-checklist_task_${id}_cta`}
              data-name={`onboarding-checklist-${id}-cta`}
            >
              {ctaLabel} →
            </Button>
          </div>
        )}
      </div>
    </li>
  );
};

export default ChecklistTaskItem;
